import { useNavigate } from 'react-router-dom';

import { Box, Grid, Stack } from '@mui/material';

import Logo from '../../assets/images/nessle-webflow-logo.png';
import { LoggedOutFooterContainer, LoggedOutFooter, LoggedOutFooterLink } from './Footer.style';

function Footer() {
  const navigate = useNavigate();

  return (
    <LoggedOutFooterContainer>
        <LoggedOutFooter>
            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Box>
                        <img src={Logo} alt="nessle logo" width={131} />
                    </Box>
                    <Box sx={{ mt: 2, fontSize: '16px', fontFamily: 'Nunito', fontWeight: 400, lineHeight: '1.5em', color: '#817d7d' }}>
                        Personalized support for every stage of parenthood. Here for you when you need it most.
                    </Box>
                    <Box>

                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Stack spacing={4}>
                        <LoggedOutFooterLink href="https://nessle.com/blog">Blog</LoggedOutFooterLink>
                        <LoggedOutFooterLink href="https://www.nessle.com/list-resource">Onboard as a Resource</LoggedOutFooterLink>
                        <LoggedOutFooterLink href="https://assets-global.website-files.com/62b6328770c172ec59ea167d/6539e9328c4b038d166066aa_Nessle%20-%20Terms%20of%20Service%20and%20User%20Agreement%20(TC%2010.24.23).docx.pdf">
                            Parent Terms and Conditions
                        </LoggedOutFooterLink>
                        <LoggedOutFooterLink href="https://assets-global.website-files.com/62b6328770c172ec59ea167d/6539e9a2f1b0c2065c190748_Nessle%20-%20Terms%20of%20Service%20and%20Consultant%20Agreement%20(TC%2010.24.23).docx.pdf">
                            Supplier Terms and Conditions
                        </LoggedOutFooterLink>
                        <LoggedOutFooterLink href="https://assets-global.website-files.com/62b6328770c172ec59ea167d/6539e88ab01b8c534a29ec16_Nessle%20-%20Privacy%20Policy%20-%20GP%2010.24.23.docx.pdf">
                            Privacy Policy
                        </LoggedOutFooterLink>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={4}>

                </Grid>
            </Grid>
            <Box sx={{ borderTop: '1px solid #e0dbdb', color: '#817d7d', fontFamily: 'Poppins', fontWeight: 500, lineHeight: '1.9em', marginTop: '30px', paddingTop: '20px', paddingBottom: '20px' }}>
                &copy; 2024 by Nessle
            </Box>
        </LoggedOutFooter>
    </LoggedOutFooterContainer>
  );
}

export default Footer;
